import Vue, { DirectiveOptions, VNodeDirective } from 'vue'
import PerfectScrollbar from 'perfect-scrollbar'

interface ScrollbarElement extends HTMLElement {
    ps?: any
}

/**
 * Attaches a PerfectScrollbar to an element
 *
 * Element used must have position: relative and overflow: hidden (or no overflow prop)
 *
 * Scrollbar can be enabled and disabled by passing a truthy or falsey value,
 * note that undefined will enable the scrollbar
 */
const Scrollbar: DirectiveOptions = {
    inserted(el: ScrollbarElement, binding) {
        if ((binding.value || binding.value === undefined) && !el.ps) {
            el.ps = new PerfectScrollbar(el)
        }
    },

    update(el: ScrollbarElement, binding) {
        if ((binding.value || binding.value === undefined) && !el.ps) {
            el.ps = new PerfectScrollbar(el)
        } else if (!binding.value && binding.value !== undefined && el.ps) {
            el.ps.destroy()
            el.ps = null
        }
    },

    unbind(el: ScrollbarElement) {
        if (el.ps) {
            el.ps.destroy()
            el.ps = null
        }
    }
}

export default Scrollbar
